import { useEffect, useState } from 'react';
import { api, type ReferralInfo } from '../api';

export function ReferralPage() {
  const [data, setData] = useState<ReferralInfo | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [toast, setToast] = useState<string | null>(null);

  useEffect(() => {
    api.referral().then(setData).catch((e) => setError(e instanceof Error ? e.message : 'Ошибка'));
  }, []);

  if (error) return <div className="container"><div className="error">{error}</div></div>;
  if (!data) return <div className="container">Загрузка…</div>;

  async function copy(text: string) {
    try {
      await navigator.clipboard.writeText(text);
      setToast('Ссылка скопирована');
    } catch {
      setToast('Не удалось скопировать');
    }
    setTimeout(() => setToast(null), 2200);
  }

  return (
    <div className="container">
      <h1>Рефералки</h1>
      <div className="referral-gift">
        <div className="referral-gift-badge">30 дней в подарок 🎁</div>
        <h2 className="referral-gift-title">Приглашайте друзей — получайте бесплатный VPN</h2>
        <p className="referral-gift-text">
          За каждого друга, который зарегистрируется и оплатит первую подписку, вам автоматически
          начисляется <strong>30 дней VPN бесплатно</strong>. Друзей можно приглашать сколько угодно —
          и так же бесконечно продлевать подписку бесплатно.
        </p>
      </div>

      {data.webReferralLink && (
        <div className="card">
          <h2>Ссылка для друзей</h2>
          <p className="muted" style={{ marginBottom: 12 }}>Нажмите, чтобы скопировать и поделиться:</p>
          <button
            type="button"
            className="copy-field"
            onClick={() => void copy(data.webReferralLink!)}
            title="Скопировать ссылку"
          >
            <code className="copy-field-text">{data.webReferralLink}</code>
            <span className="copy-field-icon" aria-hidden="true">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
              </svg>
            </span>
          </button>
        </div>
      )}

      {data.telegramReferralLink && (
        <div className="card">
          <h2>Ссылка в Telegram</h2>
          <p className="muted" style={{ marginBottom: 12 }}>Нажмите, чтобы скопировать и поделиться:</p>
          <button
            type="button"
            className="copy-field"
            onClick={() => void copy(data.telegramReferralLink!)}
            title="Скопировать ссылку"
          >
            <code className="copy-field-text">{data.telegramReferralLink}</code>
            <span className="copy-field-icon" aria-hidden="true">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
              </svg>
            </span>
          </button>
        </div>
      )}

      <div className="card">
        <div className="row"><span>Всего приглашено</span><span>{data.totalReferred}</span></div>
        <div className="row">
          <span>Бесплатных дней получено</span>
          <span>{data.rewardedCount * 30}</span>
        </div>
      </div>
      {data.referred.length > 0 && (
        <div className="card">
          <h2>Приглашённые</h2>
          {data.referred.map((r) => (
            <div key={r.id} className="row">
              <span>{r.referredLabel ?? 'без имени'}</span>
              <span className={`badge ${r.rewardedAt ? 'ok' : 'warn'}`}>{r.rewardedAt ? 'награда выдана' : 'ожидание оплаты'}</span>
            </div>
          ))}
        </div>
      )}
      {toast && <div className="toast">{toast}</div>}
    </div>
  );
}
